import React from 'react';
import * as actionCreators from '../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-date-picker';
import './styles.css';

function Inputs({
  id,
  ref,
  type,
  value,
  name,
  handleChange,
  handleChangeAdmin,
  placeholder,
  options,
  title,
  step,
  maxDate,
  minDate,
  disabled,
  onClick,
  change,
  maxLength,
  className,
  onKeyPress,
  loadOptions,
  icon,
  firstClass,
  isMulti,
  rows,
}) {
  const customSelectHandleChange = (e) => {
    if (step === 'admin') {
      handleChangeAdmin({ name, value: e.value });
      return;
    }
    if (change) change(e);
    if (step && handleChange) handleChange({ ...e, step, target: { name, value: e.value } });
  }

  const customTextHandleChange = (e) => {
    if (step === 'admin') {
      handleChangeAdmin({ name, value: e.target.value });
      return;
    }
    if (change) change(e);
    if (step && handleChange) handleChange({ ...e, step });
  }

  const customDateHandleChange = (e) => {
    let date = e.target.value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1/$2')
      .substring(0, 10);

    if (step === 'admin') {
      handleChangeAdmin({ name, value: date });
      return;
    }
    if (change) change(date);
    if (step) handleChange({ step, target: { name, value: date } });
  }

  const customDatePickerHandleChange = (date) => {
    if (step === 'admin') {
      handleChangeAdmin({ name, value: date });
      return;
    }
    if (change) change(date);
    if (step) handleChange({ step, target: { name, value: date } });
  }

  const menuStyles = {
    option: (provided, state) => ({
      ...provided,
      // display: state.mainReducer.isSelected && 'none',
    }),
    control: (styles) => ({
      ...styles,
      backgroundColor: '#fff',
      borderRadius: '10px',
      width: '100%',
      height: '50px',
      color: 'black',
      paddingLeft: '10px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
    }),
  };

  const defaultStyles = {
    option: (provided, state) => ({
      ...provided,
      // display: state.mainReducer.isSelected && 'none',
    }),
    control: (styles) => ({
      ...styles,
      borderRadius: '10px',
      borderColor: '#d9d9d9',
      width: '100%',
      height: '50px',
      color: 'black',
      paddingLeft: '10px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
    }),
  };

  switch (type) {
    case 'selectMenu':
      return (
        <Select
          key={id}
          placeholder={placeholder}
          options={options}
          styles={menuStyles}
          theme={theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              neutral50: '#000000',
            },
          })}
          onChange={customSelectHandleChange}
          value={options.length > 0 ? options.filter(opt => opt.value === value) : []}
          isDisabled={disabled}
        />
      );
    case 'select':
      return (
        <div className={className ? className : ''}>
          {title && <h3 className='color-title-blue'>{title}</h3>}
          <Select
            key={id}
            placeholder=""
            options={options}
            styles={defaultStyles}
            theme={theme => ({
              ...theme,
              colors: {
                ...theme.colors,
                neutral50: '#163275',
              },
            })}
            isMulti={isMulti}
            onChange={customSelectHandleChange}
            isDisabled={disabled}
            value={isMulti ? value : (options.length > 0 ? options.filter(opt => opt.value === value) : [])}
          />
        </div>
      );
    case 'asyncselect':
      return (
        <div>
          {title && <h3 className='color-title-blue'>{title}</h3>}
          <AsyncSelect
            key={id}
            placeholder={placeholder}
            loadOptions={loadOptions}
            styles={defaultStyles}
            theme={theme => ({
              ...theme,
              colors: {
                ...theme.colors,
                neutral50: '#163275',
              },
            })}
            onChange={customSelectHandleChange}
            isDisabled={disabled}
            // cacheOptions
            defaultOptions
          // value={options.length > 0 ? options.filter(opt => opt.value === value) : []}
          />
        </div>
      );
    case 'datepicker':
      return (
        <div>
          {title && <h3 className='color-title-blue'>{title}</h3>}
          <DatePicker
            className={"dpicker"}
            key={id}
            onChange={(date) => customDatePickerHandleChange(date)}
            value={value}
            format="dd/MM/yyyy"
            maxDate={maxDate}
            minDate={minDate}
            disabled={disabled}
            dayPlaceholder=''
            yearPlaceholder=''
            monthPlaceholder=''
          />
        </div>
      );
    case 'date':
      return (
        <div>
          {title && <h3 className='color-title-blue'>{title}</h3>}
          <input
            key={id}
            className={`input-field ${disabled ? 'disabled' : ''} ${className ? className : ''}`}
            name={name}
            type={'tel'}
            placeholder={placeholder || ''}
            value={value}
            onChange={(date) => customDateHandleChange(date)}
            onKeyPress={onKeyPress}
            disabled={disabled}
            maxLength={maxLength}
            autoComplete={"off"}
          />
        </div>
      );
    case 'textarea':
      return (<div className={firstClass ? firstClass : ''}>
        {title && <h3 className='color-title-blue'>{title}</h3>}
        <div className={icon ? "d-flex flex-nowrap input-icon m-0" : ""}>
          {icon && <span class="input-group-text change-input">{icon}</span>}
          <textarea
            key={id}
            className={`input-field ${disabled ? 'disabled' : ''} ${className ? className : ''}`}
            name={name}
            rows={rows || 20}
            placeholder={placeholder}
            value={value}
            onChange={customTextHandleChange}
            onKeyPress={onKeyPress}
            disabled={disabled}
            maxLength={maxLength}
            autoComplete={"off"}
            ref={ref}
            id={id}
          />
        </div>
      </div>
      );
    case 'button':
      return (
        <div
          className={`nextButton ${className ? className : ''} ${disabled ? 'disabled' : ''}`}
          onClick={!disabled && onClick}
        >
          {title}
        </div>
      )
    default:
      return (
        <div className={firstClass ? firstClass : ''}>
          {title && <h3 className='color-title-blue'>{title}</h3>}
          <div className={icon ? "d-flex flex-nowrap input-icon m-0" : ""}>
            {icon && <span class="input-group-text change-input">{icon}</span>}
            <input
              key={id}
              className={`input-field ${disabled ? 'disabled' : ''} ${className ? className : ''}`}
              name={name}
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={customTextHandleChange}
              onKeyPress={onKeyPress}
              disabled={disabled}
              maxLength={maxLength}
              autoComplete={"off"}
              ref={ref}
              id={id}
            />
          </div>
        </div>
      );
  };
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch)
};

export default connect(null, mapDispatchToProps)(Inputs);
